import "react-loading-skeleton/dist/skeleton.css";

import Skeleton from "react-loading-skeleton";
import ImageCard from "../shared/ImageCard";
import type {
  ImageCardCustomStyles,
  ImageCardImageProps
} from "../shared/ImageCard/imageCard.types";

import s from "./serviceItem.module.scss";

export const SkeletonServiceItem = () => (
  <div className={s.wrapper}>
    <div className={s.image_wrapper}>
      <Skeleton width={240} height={160} className={s.skeleton} />
    </div>
    <div className={s.content}>
      <h2 className="subtitle-md">
        <Skeleton height={40} />
      </h2>
      <p className="body-text-sm">
        <Skeleton height={90} />
      </p>
      <a>
        <Skeleton width={75} height={25} />
      </a>
    </div>
  </div>
);

export type ServiceItemProps = {
  image: string;
  isPetAnjoService: boolean;
  title: string;
  description: string;
  link: string;
};

const ServiceItem = ({
  image,
  isPetAnjoService,
  title,
  description,
  link
}: ServiceItemProps) => {
  const isPetPark = title === "Pet Park";
  const imageProps: ImageCardImageProps = {
    src: image,
    alt: title,
    fetchPriority: "high"
  };

  const customStyles: ImageCardCustomStyles = {
    root: {
      position: "relative",
      width: "24.2rem",
      borderRadius: "var(--token-border-radius-lg)",
      maxWidth: "100%"
    },
    image: {
      width: 240,
      height: 160,
      borderBottomRightRadius: "var(--token-border-radius-lg)"
    }
  };

  const handleLink = () => {
    return !isPetPark ? { link, outsideLink: true } : undefined;
  };

  return (
    <ImageCard
      imageProps={imageProps}
      customStyles={customStyles}
      linkProps={handleLink()}
    >
      {isPetAnjoService && (
        <div className={s.hightlight}>
          <img
            src="/inst/img/logo-pet-anjo.svg"
            alt="Este é um serviço em parceria com a Pet Anjo"
            fetchPriority="high"
            width={100}
            height={28}
          />
        </div>
      )}
      <div className={s.content}>
        <h2 className="subtitle-md">{title}</h2>
        <p className="body-text-sm">{description}</p>
        <div className={s.link_container}>
          {!isPetPark && (
            <a
              className={isPetAnjoService ? "link link-pa-blue" : "link"}
              href={link}
            >
              Saiba mais
            </a>
          )}
        </div>
      </div>
    </ImageCard>
  );
};

export default ServiceItem;
